import { render, staticRenderFns } from "./addDataRoleU.vue?vue&type=template&id=0a9660aa"
import script from "./addDataRoleU.vue?vue&type=script&lang=js"
export * from "./addDataRoleU.vue?vue&type=script&lang=js"
import style0 from "./addDataRoleU.vue?vue&type=style&index=0&id=0a9660aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports